module.exports = __webpack_public_path__ + "static/media/matilde-hat-china-angry.842b8492.png";